module.exports = __webpack_public_path__ + "static/media/landing-2.19298c32.jpg";